import styled from '@emotion/styled'

export const DateTimeSeparator = styled.span``
